import cx from 'classnames';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import './WorkshopLiveBadge.scss';

const translationPrefix = 'workshops.card';

export type WorkshopLiveBadgeVariant =
  | 'card3'
  | 'clickable'
  | 'vod'
  | 'overlay'
  | 'card3dx'
  | 'ovh'
  | 'accordion'
  | 'compact';

type WorkshopLiveBadgeProps = {
  className?: string;
  sessionStatus?: boolean;
  onImage?: boolean;
  variant?: WorkshopLiveBadgeVariant;
};

const WorkshopLiveBadge: FC<WorkshopLiveBadgeProps> = ({
  className,
  sessionStatus,
  onImage,
  variant = 'card3',
}) => {
  const { t } = useTranslation();
  const label = t(`${translationPrefix}.live`);

  if (!sessionStatus) return null;

  return (
    <span
      className={cx(
        'workshop-live-badge',
        `workshop-live-badge--${variant}`,
        onImage && 'workshop-live-badge--on-image',
        className,
      )}
      role="status"
      aria-label={label}
    >
      <span className="workshop-live-badge__dot" aria-hidden />
      <span className="workshop-live-badge__label">{label}</span>
    </span>
  );
};

export { WorkshopLiveBadge };
